const prefix = '@@seat-selection-workflow';

const MOUSE_DOWN = `${prefix}/MOUSE_DOWN`;
const MOUSE_DRAG = `${prefix}/MOUSE_DRAG`;
const MOUSE_UP = `${prefix}/MOUSE_UP`;
const MOUSE_MOVE = `${prefix}/MOUSE_MOVE`;
const MOUSE_DOUBLE_CLICK = `${prefix}/MOUSE_DOUBLE_CLICK`;
const KEY_DOWN = `${prefix}/KEY_DOWN`;
const KEY_UP = `${prefix}/KEY_UP`;
const SET_TOOL = `${prefix}/SET_TOOL`;
const SET_SELECTED_OBJECTS = `${prefix}/SET_SELECTED_OBJECTS`;
const SET_SELECTION = `${prefix}/SET_SELECTION`;
const SET_TRANSFORMATION = `${prefix}/SET_TRANSFORMATION`;
const SET_SNAP_TO_GRID = `${prefix}/SET_SNAP_TO_GRID`;
const SET_GRID_SIZE = `${prefix}/SET_GRID_SIZE`;
const SET_SHOW_GRID = `${prefix}/SET_SHOW_GRID`;
const CHANGE_SELECTION_ARC = `${prefix}/CHANGE_SELECTION_ARC`;
const ZOOM_VIEW_BOX = `${prefix}/ZOOM_VIEW_BOX`;
const MOVE_VIEW_BOX = `${prefix}/MOVE_VIEW_BOX`;
const SET_VIEW_BOX = `${prefix}/SET_VIEW_BOX`;
const SET_SAVING_SUCCEEDED = `${prefix}/SET_SAVING_SUCCEEDED`;
const SET_SAVING_FAILED = `${prefix}/SET_SAVING_FAILED`;
const SET_SAVING_IN_PROGRESS = `${prefix}/SET_SAVING_IN_PROGRESS`;
const CREATE_NOTIFICATION = `${prefix}/CREATE_NOTIFICATION`;
const DELETE_NOTIFICATION = `${prefix}/DELETE_NOTIFICATION`;
const SET_SHOW_REFERENCE_IMAGE = `${prefix}/SET_SHOW_REFERENCE_IMAGE`;
const SET_SHOW_IMAGE_TO_BUYERS = `${prefix}/SET_SHOW_IMAGE_TO_BUYERS`;
const SET_REFERENCE_IMAGE = `${prefix}/SET_REFERENCE_IMAGE`;
const SET_REFERENCE_IMAGE_POSITION = `${prefix}/SET_REFERENCE_IMAGE_POSITION`;
const SET_REFERENCE_IMAGE_ZOOM = `${prefix}/SET_REFERENCE_IMAGE_ZOOM`;
const RESET_WORKFLOW = `${prefix}/RESET_WORKFLOW`;
const SET_REFERENCE_IMAGE_QUESTION_ASKED = `${prefix}/SET_REFERENCE_IMAGE_QUESTION_ASKED`;
const SET_REFERENCE_IMAGE_CONFIGURATION_OPEN = `${prefix}/SET_REFERENCE_IMAGE_CONFIGURATION_OPEN`;
const SET_HALL_LOADED = `${prefix}/SET_HALL_LOADED`;
const SET_DUPLICATE_LABELS = `${prefix}/SET_DUPLICATE_LABELS`;
const COPY_TO_CLIPBOARD = `${prefix}/COPY_TO_CLIPBOARD`;
const PASTE_FROM_CLIPBOARD = `${prefix}/PASTE_FROM_CLIPBOARD`;
const SET_IS_BROWSING = `${prefix}/SET_IS_BROWSING`;

export {
    MOUSE_DOWN,
    MOUSE_DRAG,
    MOUSE_UP,
    MOUSE_MOVE,
    MOUSE_DOUBLE_CLICK,
    KEY_DOWN,
    KEY_UP,
    SET_TOOL,
    SET_SELECTED_OBJECTS,
    SET_SELECTION,
    SET_TRANSFORMATION,
    CHANGE_SELECTION_ARC,
    SET_SNAP_TO_GRID,
    SET_GRID_SIZE,
    SET_SHOW_GRID,
    ZOOM_VIEW_BOX,
    MOVE_VIEW_BOX,
    SET_SAVING_FAILED,
    SET_SAVING_IN_PROGRESS,
    SET_SAVING_SUCCEEDED,
    SET_VIEW_BOX,
    CREATE_NOTIFICATION,
    DELETE_NOTIFICATION,
    SET_SHOW_REFERENCE_IMAGE,
    SET_SHOW_IMAGE_TO_BUYERS,
    SET_REFERENCE_IMAGE,
    SET_REFERENCE_IMAGE_POSITION,
    SET_REFERENCE_IMAGE_ZOOM,
    RESET_WORKFLOW,
    SET_REFERENCE_IMAGE_QUESTION_ASKED,
    SET_REFERENCE_IMAGE_CONFIGURATION_OPEN,
    SET_HALL_LOADED,
    SET_DUPLICATE_LABELS,
    COPY_TO_CLIPBOARD,
    PASTE_FROM_CLIPBOARD,
    SET_IS_BROWSING,
};
